export const STATUS = {
	[true]: 'page.categories.status.active',
	[false]: 'page.categories.status.inActive',
};
